// extracted by mini-css-extract-plugin
export default {"container":"Hfqj_z2kU725km75jgSK"};